import * as React from 'react';
import { FeedItem } from '../feed';

export interface FeedEntrySummaryProps {
  entry: FeedItem;
  onEdit: Function;
  onMoveDown: Function;
  onMoveUp: Function;
}

export const FeedEntrySummary = (props: FeedEntrySummaryProps) => (
  <div className="flex pv4">
    <div className="flex-auto w-40 f4 b">
      {props.entry.name || 'New Item'}
    </div>
    <div className="flex-auto w-30 white-50">
      {props.entry.description_text || 'Add a caption'}
    </div>
    <div className="flex-auto w-20 ttu tc white-50">
      {props.entry.type}
    </div>
    <div className="flex-auto tc pl3">
      <button
        type="button"
        className="tc gold b dib link bg-transparent bw0 pointer dim"
        onClick={() => props.onEdit()}
      >
        Edit
      </button>
    </div>
    <div className="flex-auto tr pl3">
      <button
        type="button"
        className="tc gold b dib link bg-transparent bw0 pointer dim"
        onClick={() => props.onMoveUp()}
      >
        ↑
      </button>
      <button
        type="button"
        className="tc gold b dib link bg-transparent bw0 pointer dim"
        onClick={() => props.onMoveDown()}
      >
        ↓
      </button>
    </div>
  </div>
);

export default FeedEntrySummary;
